$(document).ready(function () {
  $("#toggle-header").on("click", function(e) {
    e.stopPropagation();
    $("#header_card").toggleClass("d-none");
  })

  $(document).on("click", function(e) {
    $("#header_card").addClass("d-none");
  });

  const lgBreakpoint = 992;
  if ($(window).width() > lgBreakpoint) {
    $("#profile_link").on("click", function(e) {
      e.stopPropagation();
      $("#header_card").toggleClass("d-none");
      $("#transactions_card").addClass("d-none");
    });

    $("#transactions_link").on("click", function(e) {
      e.stopPropagation();
      $("#transactions_card").toggleClass("d-none");
      $("#header_card").addClass("d-none");
    })

    $(document).on("click", function(e) {
      $("#header_card").addClass("d-none");
      $("#transactions_card").addClass("d-none");
    });
  }
});
